import React, { useState, useRef } from 'react';
import { Button, ButtonProps } from 'antd';
// import debounce from 'lodash/debounce';

interface Props extends ButtonProps {
    loadingText?: string;
    isNeedLoad?: boolean;
    onClick?: (
        e: React.MouseEvent<HTMLElement, MouseEvent>,
        ...arg: any[]
    ) => void;
}

// 封装的按钮组件
const CssBtn: React.FC<Props> = (props) => {
    const btnRef = useRef({ loading: false });
    const { children, onClick, isNeedLoad = true, ...restProps } = props;
    const [loading, setLoading] = useState(false);
    const handleClick = async (e, ...arg) => {
        if (!isNeedLoad) {
            onClick?.(e, ...arg);
            return;
        }
        if (btnRef?.current?.loading || loading) return;
        btnRef.current.loading = true;
        setLoading(true);
        try {
            // 调用传入的onClick事件,有可能传入的是函数执行完后是promise
            const back = onClick?.(e, ...arg);
            if (back instanceof Promise) {
                back.finally(() => {
                    // btnRef.current.loading = false;
                    // setLoading(false);
                    setTimeout(() => {
                        btnRef.current.loading = false;
                        setLoading(false);
                    }, 2000);
                });
            } else {
                setTimeout(() => {
                    btnRef.current.loading = false;
                    setLoading(false);
                }, 2000);
            }
        } catch (err) {
            btnRef.current.loading = false;
            setLoading(false);
        }
    };

    return (
        <Button
            loading={loading}
            {...restProps}
            onClick={handleClick}
        >
            {children}
        </Button>
    );
};

export default CssBtn;
